import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const previousStepFields: FieldInterface[] = []

export const previousStepRelations: RelationInterface[] = []
